import axios from 'axios'
import {accessSessionTokenKeyName, loggedInAdminAccessToken} from 'src/utils/constants'

const getAuthHeaders = () => {
  const token = localStorage.getItem(accessSessionTokenKeyName)
  const adminToken = localStorage.getItem(loggedInAdminAccessToken)

  return {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
    Accept: 'application/json',
    xadmin: adminToken || null,
  }
}

export const payoutApiGet = async <T,>(path: string) => {
  const response = await axios.get<T>(`${process.env.REACT_APP_API_URL}${path}`, {
    headers: getAuthHeaders(),
  })
  return response.data
}

export const payoutApiPost = async <T, D>(path: string, data: D) => {
  const response = await axios.post<T>(
    `${process.env.REACT_APP_API_URL}${path}`,
    data,
    {
      headers: getAuthHeaders(),
    }
  )

  return response.data
}